import { useState, useEffect } from 'react';
import axios from 'axios';
import { getBackendUrl } from '@/lib/backendUrl';

const API = getBackendUrl();

function authHeaders() {
  const t = localStorage.getItem('access_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/**
 * 2026-11 — Sales Invoicing halt. A single, always-reachable backend
 * check (GET /api/sales-invoicing/module-status, deliberately NOT behind
 * the same kill switch it reports on) drives whether the Sales Invoicing
 * / Invoice List menu tiles and pages show the real workspace or a
 * paused notice. Defaults to `enabled: false` while loading AND fails
 * CLOSED (enabled: false) if the check itself errors, so the real
 * workspace, its menu tiles, and any write/export call never flash on
 * screen before the paused answer is actually known.
 */
export function useSalesInvoicingModuleStatus() {
  const [state, setState] = useState({ enabled: false, loading: true, pausedMessage: null });

  useEffect(() => {
    let active = true;
    axios.get(`${API}/api/sales-invoicing/module-status`, { headers: authHeaders() })
      .then(({ data }) => {
        if (!active) return;
        setState({ enabled: !!data.enabled, loading: false, pausedMessage: data.paused_message || null });
      })
      .catch(() => {
        if (!active) return;
        setState({ enabled: false, loading: false, pausedMessage: null });
      });
    return () => { active = false; };
  }, []);

  return state;
}
